"use strict";

exports.__esModule = true;
exports.LeadText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = require("./Text");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Shows lead text.
 * @component
 */
var LeadText = exports.LeadText = (0, _styledComponents["default"])(_Text.Text).withConfig({
  displayName: "LeadText",
  componentId: "sc-fkpdox-0"
})(["color:", ";font-size:", ";line-height:1.2;h1 + &,h2 + &,h3 + &{margin-top:-0.5rem;}"], (0, _Theme.val)("LeadTextColor"), (0, _Theme.val)("LeadTextFontSize"));